import React, { useEffect, useState } from "react";
import UserTable from "./UserTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUsers, userDeleteAction, softDeleteUser, restoreUser } from "../../redux/actions/userAction";

const USERS_TABLE_STATE_KEY = "usersTableState";

const loadUsersTableState = () => {
    try {
        const raw = sessionStorage.getItem(USERS_TABLE_STATE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

const Users = () => {
    const history = useNavigate();
    const dispatch = useDispatch();

    const [savedState] = useState(loadUsersTableState);
    const [search, setSearch] = useState(savedState.search || "");
    const [status, setStatus] = useState(savedState.status || "ALL");
    const [first, setFirst] = useState(savedState.first || 0);
    const [rows, setRows] = useState(savedState.rows || 50);
    const [loading, setLoading] = useState(false);

    const refresh = () => dispatch(getUsers(setLoading, search, status));

    useEffect(() => {
        dispatch(getUsers(setLoading, search, status));
    }, [dispatch, search, status]);

    let allUsers = useSelector((state) => state.user.allUsers);

    const handleDeleteUser = async (id) => {
        await dispatch(userDeleteAction(id, refresh));
    };

    const handleSoftDeleteUser = async (id) => {
        await dispatch(softDeleteUser(id, refresh));
    };

    const handleRestoreUser = async (id) => {
        await dispatch(restoreUser(id, refresh));
    };

    const users = (allUsers || []).map((item) => ({
        ...item,
        time: new Date(item.time),
    }));

    // Reset to the first page when the search term, status filter or list length changes
    useEffect(() => {
        setFirst(0);
    }, [search, status, users.length]);

    // Preserve page/rows/search across navigation so a user opened from
    // page 3 returns to page 3 when navigating back
    useEffect(() => {
        sessionStorage.setItem(USERS_TABLE_STATE_KEY, JSON.stringify({ first, rows, search, status }));
    }, [first, rows, search, status]);

    return (
        <UserTable
            heading="All Users"
            allUsers={users}
            loading={loading}
            setLoading={setLoading}
            history={history}
            search={search}
            setSearch={setSearch}
            status={status}
            setStatus={setStatus}
            deleteUser={handleDeleteUser}
            softDeleteUser={handleSoftDeleteUser}
            restoreUser={handleRestoreUser}
            first={first}
            rows={rows}
            onPage={(event) => {
                setFirst(event.first);
                setRows(event.rows);
            }}
        />
    );
};

export default Users;